import React from 'react'

import IFormPage from '../../../../../interfaces/form-page'
import Guide from '../../../../../components/guide'
import CallWaiterForm from './call-waiter-form'

import {
  Container,
  ContentWrapper,
  Title,
} from './styles'

type IProps = any & IFormPage

const CallWaiterEditor = ({
  dataForm,
  onSubmit,
  initialData,
  isToUpdate = false,
}: IProps) => (
  <Container>
    <ContentWrapper>
      <div>
        <Title>Cadastre as principais opções solicitadas ao garçom</Title>
        <CallWaiterForm
          dataForm={dataForm}
          onSubmit={onSubmit}
          initialData={initialData}
          isToUpdate={isToUpdate}
        />
      </div>
      <div>
        <Guide
          title="Orientações"
          instructions={[
            'Adicione as perguntas que mais são solicitadas para facilitar o atendimento',
            'Ex: Trazer mais talheres, adicione a opção de específicar a quantidade desejada',
            'Ex: Fechar conta',
            'Ex: Trazer mais copos, adicione a opção de específicar a quantidade desejada',
          ]}
        />
      </div>
    </ContentWrapper>
  </Container>

)

export default CallWaiterEditor
